import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, AlertCircleIcon, ThumbsUpIcon, ClipboardListIcon } from 'lucide-react';
export function FitSection() {
  const fitList = ['People looking for drug-free, non-surgical support', 'Active adults wanting to recover and move better', 'Patients with inflammation-related discomfort', 'People with soft-tissue, joint, tendon, or overuse concerns', 'Patients open to a series-based care plan'];
  const consultList = ['Not every condition is appropriate for laser therapy', 'Some symptoms require medical evaluation first', 'Treatment frequency depends on the person and condition', 'Safety precautions are important', 'Results vary'];
  return <section className="py-16 md:py-20 bg-brand-gray-light" data-id="element-125">
      <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 max-w-3xl mx-auto" data-id="element-127">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-brand-navy mb-4 leading-tight" data-id="element-128">
            Is Laser Therapy Right for Everyone?
          </h2>
          <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-129">
            Laser therapy is a focused option — not a fit for every person or
            every condition. Here is when it tends to be a good match, and why a
            consultation matters.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-130">
          {/* Good fit card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-white rounded-2xl shadow-md border-2 border-brand-teal/30 overflow-hidden" data-id="element-131">
            <div className="bg-brand-teal py-4 px-6 flex items-center gap-3" data-id="element-132">
              <div className="w-9 h-9 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-133">
                <ThumbsUpIcon className="w-5 h-5 text-white" data-id="element-134" />
              </div>
              <h3 className="text-base md:text-lg font-black text-white leading-tight" data-id="element-135">
                Laser Therapy May Be a Good Fit For
              </h3>
            </div>
            <div className="p-6 md:p-7" data-id="element-136">
              <ul className="space-y-3.5" data-id="element-137">
                {fitList.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-138">
                    <CheckCircle2Icon className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-139" />
                    <span className="text-brand-charcoal font-medium leading-snug text-sm md:text-base" data-id="element-140">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>

          {/* Consultation matters card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white rounded-2xl shadow-md border-2 border-brand-navy/20 overflow-hidden" data-id="element-141">
            <div className="bg-brand-navy py-4 px-6 flex items-center gap-3" data-id="element-142">
              <div className="w-9 h-9 bg-white/15 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-143">
                <ClipboardListIcon className="w-5 h-5 text-white" data-id="element-144" />
              </div>
              <h3 className="text-base md:text-lg font-black text-white leading-tight" data-id="element-145">
                A Consultation Matters Because
              </h3>
            </div>
            <div className="p-6 md:p-7" data-id="element-146">
              <ul className="space-y-3.5" data-id="element-147">
                {consultList.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-148">
                    <AlertCircleIcon className="w-5 h-5 text-brand-navy flex-shrink-0 mt-0.5" data-id="element-149" />
                    <span className="text-brand-charcoal font-medium leading-snug text-sm md:text-base" data-id="element-150">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center bg-white p-5 md:p-6 rounded-2xl border border-gray-200 shadow-sm max-w-3xl mx-auto" data-id="element-151">
          <p className="text-sm md:text-base text-brand-navy font-bold leading-relaxed" data-id="element-152">
            Paragon Chiropractic will help determine whether laser therapy is
            appropriate for your situation.
          </p>
        </motion.div>
      </div>
    </section>;
}